/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Select_Previous_EventInputs */



/**
* | output |
* | --- |
* | "Select Previous Event" |
*
* @param {Shortcut_Keys_Name_Select_Previous_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_select_previous_event = /** @type {((inputs?: Shortcut_Keys_Name_Select_Previous_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Select_Previous_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner l'evenement precedent")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorheriges Ereignis auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona evento precedente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите предыдущее событие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar evento anterior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择上一个事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("前のイベントを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पिछला कार्यक्रम चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o evento anterior")
	return /** @type {LocalizedString} */ ("Select Previous Event")
});